export default {
  title: '商城装修',
  previewTitle: '商城中心',
  pageSetting: '页面设置',
  pageTitle: '页面标题',
  pageTitlePlaceholder: '请输入页面标题',
  defaultPageTitle: '积分商城',
  modules: '功能模块',
  moduleList: '模块列表',
  moduleConfig: '模块配置',
  editText: '编辑文字',
  editTextTitle: '编辑文字',
  moduleNames: {
    Banner: '轮播图',
    Picture: '图片橱窗',
  },
  labelName: {
    pointName: '积分',
  },
  langSection: '语言版本',
  langEnglish: 'English',
  langZhTw: '繁體中文',
  langZhCn: '简体中文',
  langJaJp: 'Japanese',
  tabs: {
    title: '页面标题',
    carousel: '轮播图',
    showcase: '图片橱窗',
  },
  delete: '删除',
  image: '图片',
  show: '显示',
  hide: '隐藏',
  carouselTip: '最多支持上传 5 张图片，如果隐藏则不显示上传图片入口并且终端也不显示顶部的图片',
  uploadImage: '上传图片',
  layout: '布局',
  layoutAlone: '独占一行',
  layoutBigOne: '大图一行',
  layoutStack2: '堆积两行',
  unit: '单位',
  unitPlaceholder: '请输入单位',
  previewBack: '返回',
  previewExchange: '立马兑换',
  previewAll: '全部',
  mockItemTitle: '商品名称{index}',
  save: '保存',
  saveSuccess: '保存成功',
  syncConfig: '同步配置',
  syncConfigTitle: '同步配置',
  syncConfigDesc: '将当前语言（{lang}）的配置同步到以下语言：',
  syncConfigSuccess: '同步成功',
  formLabel: {
    isShow: '是否显示',
    show: '显示',
    hide: '隐藏',
    image: '图片',
    layoutType: '布局类型',
    layoutAlone: '独自占一行',
    layoutBigOne: '大图一行',
    layoutStack2: '堆积两列',
  },
};
